import React from 'react';
import PropTypes from 'prop-types';

import { IntlProvider, addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import de from 'react-intl/locale-data/de';
import fr from 'react-intl/locale-data/fr';
import es from 'react-intl/locale-data/es';
import ko from 'react-intl/locale-data/ko';
import ja from 'react-intl/locale-data/ja';

import enMessages from '../../../languages/en.json';
import deMessages from '../../../languages/de.json';
import frMessages from '../../../languages/fr.json';
import esMessages from '../../../languages/es.json';
import koMessages from '../../../languages/ko.json';
import jaMessages from '../../../languages/ja.json';

const messages = {
  en: enMessages,
  de: deMessages,
  fr: frMessages,
  es: esMessages,
  ko: koMessages,
  ja: jaMessages,
};

addLocaleData([...en, ...de, ...fr, ...es, ...ko, ...ja]);

const PageIntlProvider = ({ locale, language, children }) => {
  return (
    <IntlProvider locale={locale} messages={messages[language]}>
      {children}
    </IntlProvider>
  );
};

PageIntlProvider.propTypes = {
  locale: PropTypes.string.isRequired,
  language: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default PageIntlProvider;



// WEBPACK FOOTER //
// /tmp/build_2cb81483/src/components/provider/PageIntlProvider.js